import { render, staticRenderFns } from "./createNew.vue?vue&type=template&id=fc07ca16&scoped=true"
import script from "./createNew.vue?vue&type=script&lang=js"
export * from "./createNew.vue?vue&type=script&lang=js"
import style0 from "./createNew.vue?vue&type=style&index=0&id=fc07ca16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc07ca16",
  null
  
)

export default component.exports